export enum QueryKey {
    /**
     * Lista de Audiencias
     */
    Audiencias = 'audiencias',
    /**
     * Lista de Casos
     */
    Casos = 'casos',
    /**
     * Lista de Documentos
     */
    Documentos = 'documentos',
    /**
     * Lista de Calendario
     */
    Calendario = 'calendario',
    /**
     * VerificarExistenAlertas
     */
    VerificarExistenAlertas = 'verificarExistenAlertas',
    /**
     * GetAlertaUsuariosInfo
     */
    GetAlertaUsuariosInfo = 'getAlertaUsuariosInfo',
    /**
     * ObtenerPreferencias
     */
    ObtenerPreferencias = 'obtenerPreferencias',
    /**
     * ActualizarPreferencia
     */
    ActualizarPreferencia = 'actualizarPreferencia',
    /**
     * ActualizarMultiplesPreferencias
     */
    ActualizarMultiplesPreferencias = 'actualizarMultiplesPreferencias',
    /**
     * TwoFAConfig
     */
    TwoFAConfig = 'twoFAConfig',
    /**
     * EnableTwoFA
     */
    EnableTwoFA = 'enableTwoFA',
    /**
     * VerifyTwoFA
     */
    VerifyTwoFA = 'verifyTwoFA',
    /**
     * DisableTwoFA
     */
    DisableTwoFA = 'disableTwoFA',
    /**
     * BackUpCodesTwoFA
     */
    BackUpCodesTwoFA = 'backUpCodesTwoFA',
    /**
     * QRImageTwoFA
     */
    QRImageTwoFA = 'qRImageTwoFA',
    /**
     * AboutMe
     */
    AboutMe = 'aboutMe',
}